'use client';

import { c as _c } from "react/compiler-runtime";
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import type { UseNotificacaoSelfReturn } from '../hooks';
import { useMedicaoCadastro, useNotificacaoSelf, usePagamentoSelfPolling, useSelfStepUrl } from '../hooks';
import { expirarSessao, selectSelfAccessToken, selectSelfPagamentoIniciado } from '../store';
import { CadastroScreen } from './CadastroScreen';
import { InicioScreen, PlanosSection } from './InicioScreen';
import { PagamentoScreen } from './PagamentoScreen';
import { RevisaoScreen } from './RevisaoScreen';
import { TermosScreen } from './TermosScreen';
import { TrocarPlanoScreen } from './TrocarPlanoScreen';
const renderScreen = (vm: UseNotificacaoSelfReturn) => {
  switch (vm.step) {
    case 'cadastro':
      return <CadastroScreen vm={vm} />;
    case 'revisao':
      return <RevisaoScreen vm={vm} />;
    case 'trocarPlano':
      return <TrocarPlanoScreen vm={vm} />;
    case 'pagamento':
      return <PagamentoScreen vm={vm} />;
    case 'termos':
      return <TermosScreen vm={vm} />;
    case 'inicio':
    default:
      return <>
          <InicioScreen vm={vm} />
          <PlanosSection vm={vm} />
        </>;
  }
};
export const NotificacaoSelfWizard = () => {
  const $ = _c(8);
  const vm = useNotificacaoSelf();
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector(selectSelfAccessToken);
  const pagamentoIniciado = useAppSelector(selectSelfPagamentoIniciado);
  useMedicaoCadastro();
  const t0 = vm.step;
  const t1 = vm.goTo;
  const t2 = Boolean(accessToken);
  let t3;
  if ($[0] !== dispatch) {
    t3 = () => dispatch(expirarSessao());
    $[0] = dispatch;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== pagamentoIniciado || $[3] !== t2 || $[4] !== t3) {
    t4 = {
      temLead: t2,
      pagamentoIniciado,
      aoExpirarSessao: t3
    };
    $[2] = pagamentoIniciado;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  useSelfStepUrl(t0, t1, t4);
  usePagamentoSelfPolling();
  let t5;
  if ($[6] !== vm) {
    t5 = renderScreen(vm);
    $[6] = vm;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};